import React from "react";
import {
  EmptyPaper,
  LoadingError,
  LoadingPaper,
} from "../../components/LoadingComponents";
import { IconButton, Box, Paper, Typography, Dialog } from "@mui/material";
import columns from "./ControlRoomColumns";
import MaterialReactTable from "material-react-table";
import {
  useGetServices,
  useDeleteService,
} from "../../components/ServiceComponents";
import PageTitle from "../../components/PageTitle/PageTitle";
import { LinkDevice } from "../../components/DeviceComponents";
import { AddLink as LinkIcon, Delete as DeleteIcon } from "@mui/icons-material";
import { useState } from "react";
import { useAuthUser } from "react-auth-kit";

function ControlRoom(props) {
  // === web service queries/mutations ===
  const servicesQuery = useGetServices(false);
  const serviceDeleteMutation = useDeleteService();
  const tableColumns = columns;
  const authUser = useAuthUser();

  // === LinkDevice modal handling ===
  const [selectedService, setSelectedService] = useState({
    service_id: null,
    patient_id: null,
  });
  const [openLinkDevice, setOpenLinkDevice] = useState(false);
  const handleOpenLinkDevice = (service_id, patient_id) => {
    setSelectedService({
      service_id: service_id,
      patient_id: patient_id,
    });
    setOpenLinkDevice(true);
  };
  const handleCloseLinkDevice = () => {
    setOpenLinkDevice(false);
  };

  return (
    <main style={{ width: "100%" }}>
      <Dialog open={openLinkDevice}>
        <LinkDevice
          service_id={selectedService.service_id}
          patient_id={selectedService.patient_id}
          closeModal={handleCloseLinkDevice}
        />
      </Dialog>

      <PageTitle title="ControlRoom" />
      {servicesQuery.isLoading || servicesQuery.isIdle ? (
        <LoadingPaper />
      ) : servicesQuery.isError ? (
        <>
          <LoadingError error={servicesQuery.error} />
        </>
      ) : (
        servicesQuery.isSuccess && (
          <Paper
            style={{ minHeight: "fitContent", margin: "3vh", maxWidth: "96%" }}
          >
            <Typography variant="h6" padding={"10px"}>
              Telemonitoraggi da attivare:
            </Typography>
            {servicesQuery.data.services.length === 0 ? (
              <EmptyPaper message={"Nessun telemonitoraggio da attivare"} />
            ) : (
              <MaterialReactTable
                columns={tableColumns}
                // mostro solo i servizi non attivi   TODO da rimpiazzare con chiamata API specifica
                data={servicesQuery.data?.services || []}
                // data={servicesQuery.data.services}
                initialState={{
                  density: "compact",
                  showColumnFilters: true,
                  columnVisibility: {
                    org_name: authUser()?.role === 1 ? true : false,
                  },
                }}
                enablePagination={true}
                enableBottomToolbar={true}
                enableTopToolbar={false}
                enableSorting={true}
                muiTablePaperProps={{
                  elevation: 0,
                }}
                enableColumnResizing
                enableColumnActions={false}
                enableRowSelection={false}
                enableRowActions={true}
                displayColumnDefOptions={{
                  "mrt-row-actions": { header: "Azioni" },
                }}
                positionActionsColumn="last"
                renderRowActions={({ row }) => (
                  <Box sx={{ display: "flex", flexWrap: "nowrap", gap: "8px" }}>
                    <IconButton
                      color="success"
                      key="associate"
                      onClick={() => {
                        handleOpenLinkDevice(
                          row.original.id,
                          row.original.patient_id
                        );
                      }}
                    >
                      <LinkIcon />
                    </IconButton>

                    <IconButton
                      color="error"
                      key="delete"
                      onClick={() => {
                        serviceDeleteMutation.mutate(row.original.id);
                      }}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </Box>
                )}
              />
            )}
          </Paper>
        )
      )}
    </main>
  );
}

export default ControlRoom;
